import * as React from 'react';
import * as classNames from 'classnames';

interface ILabelTagProps {
  color?: 'orange' | 'blue';
  size?: 'normal' | 'small';
  children: React.ReactNode;
}

export default function LabelTag({
  color,
  size,
  children,
}: ILabelTagProps) {
  const classes = classNames(
    'label-tag',
    { 'label-tag--orange': color === 'orange' },
    { 'label-tag--blue': color === 'blue' },
    { 'label-tag--small': size === 'small' },
  );

  return (
    <div className={classes}>
      {children}
    </div>
  );
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/commons/src/components/label_tag.tsx